{
  "primary": {
    "primary-50": "oklch(0.981046 0.012805 221.42319)",
    "primary-100": "oklch(0.962528 0.022535 229.073806)",
    "primary-150": "oklch(0.945178 0.032646 226.304274)",
    "primary-200": "oklch(0.926674 0.041663 227.890787)",
    "primary-250": "oklch(0.911263 0.054737 226.223779)",
    "primary-300": "oklch(0.896395 0.067447 225.364647)",
    "primary-350": "oklch(0.87908 0.079726 224.961348)",
    "primary-400": "oklch(0.864091 0.092143 223.595164)",
    "primary-450": "oklch(0.793049 0.126377 232.671182)",
    "primary-500": "oklch(0.719588 0.160232 241.934243)",
    "primary-550": "oklch(0.647121 0.194114 252.085254)",
    "primary-600": "oklch(0.575113 0.229834 260.756335)",
    "primary-650": "oklch(0.504429 0.200565 260.409998)",
    "primary-700": "oklch(0.433012 0.172764 260.164397)",
    "primary-750": "oklch(0.360675 0.146274 260.290439)",
    "primary-800": "oklch(0.289999 0.117296 259.841938)",
    "primary-850": "oklch(0.238584 0.100105 260.505764)",
    "primary-900": "oklch(0.190403 0.080719 260.682766)",
    "primary-950": "oklch(0.138623 0.062732 261.699127)"
  },
  "accent": {
    "accent-50": "oklch(0.984801 0.007587 7.280361)",
    "accent-100": "oklch(0.97188 0.014232 6.700043)",
    "accent-150": "oklch(0.959029 0.020979 6.606185)",
    "accent-200": "oklch(0.946252 0.027827 6.653086)",
    "accent-250": "oklch(0.922815 0.040479 8.438397)",
    "accent-300": "oklch(0.897868 0.054828 8.39461)",
    "accent-350": "oklch(0.875166 0.068164 9.494436)",
    "accent-400": "oklch(0.850883 0.08303 10.570683)",
    "accent-450": "oklch(0.779076 0.116944 12.810782)",
    "accent-500": "oklch(0.707215 0.150378 15.602977)",
    "accent-550": "oklch(0.634722 0.184087 17.935378)",
    "accent-600": "oklch(0.561955 0.217505 20.33356)",
    "accent-650": "oklch(0.501611 0.19526 19.649998)",
    "accent-700": "oklch(0.439441 0.172351 18.724983)",
    "accent-750": "oklch(0.377602 0.149006 17.706488)",
    "accent-800": "oklch(0.316967 0.126887 17.133117)",
    "accent-850": "oklch(0.26401 0.105766 17.967115)",
    "accent-900": "oklch(0.210832 0.084535 18.772606)",
    "accent-950": "oklch(0.156795 0.062933 19.607624)"
  },
  "grey": {
    "grey-50": "oklch(0.985104 0 0)",
    "grey-100": "oklch(0.970151 0 0)",
    "grey-150": "oklch(0.95514 0 0)",
    "grey-200": "oklch(0.94007 0 0)",
    "grey-250": "oklch(0.920652 0.002558 228.786818)",
    "grey-300": "oklch(0.901624 0.003538 219.535738)",
    "grey-350": "oklch(0.882025 0.006111 223.464254)",
    "grey-400": "oklch(0.863097 0.007776 228.868893)",
    "grey-450": "oklch(0.753634 0.008885 236.605307)",
    "grey-500": "oklch(0.645222 0.009348 225.150438)",
    "grey-550": "oklch(0.536704 0.009767 225.197358)",
    "grey-600": "oklch(0.426427 0.011202 232.617199)",
    "grey-650": "oklch(0.386365 0.01045 236.835687)",
    "grey-700": "oklch(0.348204 0.010712 236.894097)",
    "grey-750": "oklch(0.308978 0.011017 236.97265)",
    "grey-800": "oklch(0.269413 0.01036 242.083865)",
    "grey-850": "oklch(0.223572 0.008405 240.274391)",
    "grey-900": "oklch(0.175228 0.006346 236.981786)",
    "grey-950": "oklch(0.126543 0.006953 243.792325)"
  }
}
